const easeInOutQuad = (time: number, startPos: number, endPos: number, duration: number): number => {
  time /= duration / 2;

  if (time < 1) return (endPos / 2) * time * time + startPos;
  time--;
  return (-endPos / 2) * (time * (time - 2) - 1) + startPos;
};

const scrollTo = (element?: Element, offset = 0, duration = 350): void => {
  if (!element) return;
  const start = element.scrollTop;
  let currentTime = 0;
  const increment = 50;

  const animateScroll = (): void => {
    currentTime += increment;

    element.scrollTop = easeInOutQuad(currentTime, start, offset, duration);

    if (currentTime < duration) {
      setTimeout(animateScroll, increment);
    }
  };

  animateScroll();
};

export const scrollIntoView = (parent: Element, child: Element, duration = 50): void => {
  const parentBounding = parent.getBoundingClientRect(),
    clientBounding = child.getBoundingClientRect();

  const parentBottom = parentBounding.bottom,
    parentTop = parentBounding.top,
    clientBottom = clientBounding.bottom,
    clientTop = clientBounding.top;

  if (parentTop >= clientTop) {
    scrollTo(parent, -(parentTop - clientTop), duration);
  } else if (clientBottom > parentBottom) {
    scrollTo(parent, clientBottom - parentBottom, duration);
  }
};
